import { Component } from '@angular/core';

@Component({
    selector: 'app-financeiro',
    templateUrl: './financeiro.component.html',
    styleUrl: './financeiro.component.css',
    standalone: false
})
export class FinanceiroComponent {

}
